export const tableRules = {
  settlementEntityName: [{ required: true, message: '请选择结算主体' }],
  settlementRate: [{ required: true, message: '请输入结算比例' }],
};
